import React, { useState, useEffect } from "react"
import Pagination from "./pagination"
import BlogHero from "./hero"
import BlogPostGallery from "./blog-post-gallery"
import TopRightPageBg from "../Site/TopRightPageBg.jsx"

const BlogHome = () => {
  const [searchQuery, setSearchQuery] = useState("")
  const [searchCategory, setSearchCategory] = useState("")
  const [searchResultCount, setSearchResultCount] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  return (
    <div className="w-full bg-gradient_bottom_page rounded-b-[50px] md:rounded-b-[100px] pb-[80px] md:pb-[116px] overflow-hidden">
      <BlogHero />

      <BlogPostGallery
        searchCategory={searchCategory}
        searchQuery={searchQuery}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setTotalPages={setTotalPages}
        setSearchResultCount={setSearchResultCount}
      />

      {/* Temporarily hidden for website v 1.0 */}
      {/* <Pagination
        totalPages={totalPages} // Assuming this is the total number of pages
        currentPage={currentPage} // Assuming this is the current page
        onPageChange={(page) => {
          // Assuming this function will navigate to the selected page
          setCurrentPage(page)
        }}
      /> */}

      <TopRightPageBg />

    </div>
  )
}

export default BlogHome